import { Daytable } from '@aclass/core/base/daytable';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fromDateTimeString'
})

export class DateTimePipe implements PipeTransform {

    /**
     * @inheritDoc
     */
    transform(value: any): Date | undefined {
        const dt = Daytable.fromDateTimeString(value);

        return dt ? dt.toDate() : undefined;
    }
}
